exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ellipsis_ellipsis__KhULR{overflow:hidden;display:inline-block;word-break:break-all;width:100%}.ellipsis_lines__2BITy{position:relative}.ellipsis_lines__2BITy .ellipsis_shadow__3iW4W{display:block;position:absolute;color:rgba(0,0,0,0);opacity:0;z-index:-999}.ellipsis_lineClamp__2dzl7{position:relative;overflow:hidden;text-overflow:ellipsis;display:-webkit-box}", ""]);

// Exports
exports.locals = {
	"ellipsis": "ellipsis_ellipsis__KhULR",
	"lines": "ellipsis_lines__2BITy",
	"shadow": "ellipsis_shadow__3iW4W",
	"lineClamp": "ellipsis_lineClamp__2dzl7"
};